import axios from "axios";

import { store } from "../redux/store";
import { authTime, isTokenExpired } from "../utils/utils";
import { getIdTokenFirebase, logoutFirebase } from "../auth/operations";
import appData from "../slices/appSlice";

export const CONTENT_TYPE = {
  Accept: "*/*",
  // Accept: "application/json",
};

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

export const apiConfigURL = axios.create({
  baseURL: process.env.REACT_APP_CONFIG_URL,
  headers: CONTENT_TYPE,
});

// Separate api object that has no interceptors
export const refreshApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: CONTENT_TYPE,
});

api.interceptors.request.use(
  async (config: any) => {
    let { idToken, loggedIn } = store.getState().auth;

    if (loggedIn && idToken && Date.now() / 1000 >= authTime(idToken) + 86400) {
      logoutFirebase();
      return config;
    }

    if (!idToken || isTokenExpired(idToken)) {
      // Token missing or expired — refresh it and read the updated value from the store
      await getIdTokenFirebase();
      idToken = store.getState().auth.idToken;
    }

    if (idToken) {
      config.headers["Authorization"] = `Bearer ${idToken}`;
    }

    return config;
  },
  async (error) => {
    if (error?.response?.status === 401) {
      await getIdTokenFirebase();
    }
  }
);

export default api;
